module.exports = __webpack_public_path__ + "static/ui-a6fa94fd2672035a9d791b9bda4fb572.svg";